const PLATFORM_DOMAINS: Record<string, string> = {
  trustpilot: 'trustpilot.com',
  tripadvisor: 'tripadvisor.com',
};

export function getPlatformFavicon(platform: string): { url: string; label: string } | null {
  const domain = PLATFORM_DOMAINS[platform.toLowerCase()];
  if (!domain) return null;
  return { url: `https://www.google.com/s2/favicons?domain=${domain}&sz=64`, label: platform.toLowerCase() };
}
